/**
 * FIX(admin-double-error): a registry of errors some UI has ALREADY shown the
 * admin inline, so the global mutation-error toast (lib/queryClient.ts) can
 * skip them.
 *
 * Why a side channel: TanStack Query's `MutationCache.onError` runs BEFORE
 * `mutateAsync` rejects, and a caller's own try/catch (e.g. ConfirmDialog's)
 * is not visible in `mutation.options.onError`. So the cache handler defers a
 * tick, and a catch block that renders the message inline marks the error
 * here in the meantime. Before: a failed ConfirmDialog confirm showed the
 * inline error AND an "Action failed" toast. After: inline only.
 *
 * WeakSet-keyed on the error object itself, so nothing leaks and no id is
 * needed. Primitives (a thrown string) can't be marked — they still toast.
 */
const handled = new WeakSet<object>();

/** Record that `err` has been surfaced to the admin inline. */
export function markErrorHandled(err: unknown): void {
  if (typeof err === 'object' && err !== null) handled.add(err);
}

/** Has some UI already shown `err` inline? */
export function isErrorHandled(err: unknown): boolean {
  return typeof err === 'object' && err !== null && handled.has(err);
}
